var _rect, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 2,
    rx: 1,
    fill: "currentColorr"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 20,
    height: 2,
    rx: 1,
    fill: "currentColorr"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 20,
    height: 2,
    rx: 1,
    fill: "currentColorr"
  })));
}

export default SvgBurger;